import { CumulioDashboard } from './dashboard-component/dashboard-component';

class CumulioService {
  _components: CumulioDashboard[] = [];
}

export default new CumulioService();
